import { useEffect } from 'react';

import { PageLayout } from '~components/page/PageLayout';
import ChangelogExtension from '~extension/changelog';
import useAppSelector from '~hooks/useAppSelector';
import useLabels from '~hooks/useLabels';
import { useNavigateToDefault } from '~hooks/useNavigateToPage';
import usePermissions from '~hooks/usePermissions';
import { selectAddonsIsChangelogEnabled } from '~store/selectors';

export default function ChangelogPage() {
  const { hlChangelog } = useLabels(['hlChangelog']);
  const navigateToDefault = useNavigateToDefault();
  const { hasViewChangelogPermission } = usePermissions();

  const isEnabled = useAppSelector(selectAddonsIsChangelogEnabled);

  useEffect(() => {
    if (!isEnabled || !hasViewChangelogPermission) {
      navigateToDefault();
    }
  }, [hasViewChangelogPermission, isEnabled, navigateToDefault]);

  return (
    <PageLayout title={hlChangelog} className="page--changelog">
      <div className="u-margin-top-lg container relative px-0">
        <div className="c-view__header u-margin-bottom-md">
          <div className="o-grid o-grid--unpad o-grid--bottom">
            <div className="o-grid__cell o-grid__cell--width-10">
              <h2>{hlChangelog} </h2>
            </div>
          </div>
        </div>
        <div className="c-view__content">
          <ChangelogExtension />
        </div>
      </div>
    </PageLayout>
  );
}
